<template>
  <div class="content">
    <div class="img_box">
      <div class="img_center">
        <div class="img_text">
          <div class="img_title">核心产品</div>
          <div class="img_content"></div>
        </div>
      </div>
    </div>
    <div class="contentCenter" v-for="(item, index) in productArr" :key="index">
      <div class="title">
        <span>{{ item.leftText }}</span>
      </div>
      <div class="text" style="text-align: left;">{{ item.text }}</div>
      <div class="park">
        <div
          class="parkLi"
          v-for="(items, indexs) in item.picArr"
          :key="indexs"
          style="overflow: hidden"
          v-lazy-container="{ selector: 'img' }"
        >
          <img :data-src="items.url" alt="" />
          <div class="parkText" :style="{'text-align': (index == 0 && indexs == 0) || (index == 2 && indexs == 1) || (index == 3 && indexs == 0) ? 'left' : 'center'}">{{ items.text }}</div>
        </div>
      </div>
      <div
        style="margin-top: 6%; display: flex; justify-content: center"
        v-if="item.btn"
      >
        <div
          class="parkBtn"
          v-for="(btnItem, btnIndex) in item.btn"
          :key="btnIndex"
        >
          {{ btnItem }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCenter",
  data() {
    return {
      productArr: [
        {
          leftText: '"云将"系统',
          text: "智慧园区一体化综合管控操作系统-“云将”OS是专为智慧园区打造的以集中管控为目的，助力园区运营管控，实现园区管理自动驾驶的新一代操作系统。将园区门禁管理、停车管理、视频监控、电梯监控、客流统计、变配电监控、火灾报警、电子巡更、信息发布、背景音乐、能源管理、楼宇控制等数十个子系统融合为一个综合管控平台，并在此基础上产生新的业务功能，从而实现智慧园区“数字化”、“孪生化”、“智慧化”、“绿色化”新四化。",
          picArr: [
            {
              url: require("../assets/我的预定（已拒绝）详情.png"),
              text: "智能运营中心（IOC）、人员通行、车辆通行、访客管理、考勤排班、会议管理、安防管理、餐饮管理、保修管理、工单管理、智慧消防、智慧能源、空间设备、资产管理、移动端应用...",
            },
            {
              url: require("../assets/product2.png"),
              text: "适用于政企园区、产业园区等各园区场景。",
            },
          ],
        },
        {
          leftText: "智慧无人仓",
          text: "智慧无人仓提高企业、单位仓储建设智能化水平，优化仓储管理流程，提高物资利用效率，规范物资存放调用。利用数字化管控手段，规范物资全过程全生命周期管理，盘活闲置物资、降本降耗、提质增效。",
          picArr: [
            {
              url: require("../assets/key-warehouse-1.png"),
              text: "采购管理、设备管理、预警提醒、进出库管理、系统管理、统计分析...",
            },
            {
              url: require("../assets/key-warehouse-2.png"),
              text: "适用于电力、石油、化工等行业的专业仓、备品备件仓、仪器仪表室、安全工...",
            },
          ],
        },
        {
          leftText: "便易访",
          text: "便易访为园区、企业、楼宇、办公场所等提供一套无纸化的线上访客登记管理平台。用户可免费试用本产品，本产品为SaaS化产品无需下载安装，只需注册即刻拥有访客登记管理功能。本产品支持远程邀请访客和访客现场扫码登记，提供访问登记效率，并可查看和导出访客记录，方便用户管理来访人员。",
          picArr: [
            {
              url: require("../assets/会面详情（已取消、已结束）.png"),
              text: "访客邀请、访客登记、访客数据管理、统计报表、签到码物料管理...",
            },
            {
              url: require("../assets/图层 21.png"),
              text: "适用于政企园区、产业园区等各园区场景。",
            },
          ],
          // btn: ["申请试用"],
        },
        {
          leftText: "测温防疫系统",
          text: "基于疫情现状的常态化，针对园区、工厂、学校、社区、楼宇、办公场所等场景进出人员进行实时测温、未防护预警、发热预警，提供进出人员的数据统计分析、报警统计分析、疫区人员布控、人员轨迹分析、人员身份鉴别、预警联动等功能模块，协助园区监管人员掌控疫情态势。",
          picArr: [
            {
              url: require("../assets/ced74993f7b411fd3323b2ceb0f520e.png"),
              text: "防疫大数据看板、管理后台、实时测温数据展示、实时报警、数据统计分析...",
            },
            {
              url: require("../assets/图层 4.png"),
              text: "适用于园区、社区、企业、学校、商场、机场、车站、酒店、楼宇、办公场所等人员进出、疫区管控场景.",
            },
          ],
        },
        {
          leftText: "云猫鼠情监测平台",
          text: "云猫监测系统利用机器视觉技术，通过摄像头自动抓拍识别老鼠（其他动物，比如猫、狗等不会被误识别，可同时排除人体干扰），自动完成老鼠计数、上报和基于大数据的统计、预测分析功能。产品支持对监测区域的老鼠观察、分析、预测。本产品全部设备放置于一个便携箱中，开箱即用，快速部署。摄像头采用无线（也支持有线连接）方式连接，减少对外部环境的依赖。",
          picArr: [
            {
              url: require("../assets/矩形 13.png"),
              text: "24小时监控抓拍、实时识别计数、自动预警提醒、实时监控查询、地图监控、数据统计分析...",
            },
            {
              url: require("../assets/Product8.png"),
              text: "适用于政企园区、产业园区等各园区场景。",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.title {
  font-size: 40px;
  color: #333;
}
.title > span:nth-of-type(2) {
  color: #0171bb;
}
.img_box {
  width: 100%;
  height: 400px;
  background-image: url(../assets/product.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img_center {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  color: #ffffff;
}
.img_title {
  width: 100%;
  margin-top: 173px;
  font-size: 60px;
}
.img_content {
  width: 1000px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 20px;
  margin-top: 26px;
}
.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 80px;
}
@media (min-width: 768px) {
  .contentCenter,
  .systemCenter,
  .bottomCenter {
    width: 800px;
  }
}
@media (min-width: 1000px) {
  .contentCenter,
  .systemCenter,
  .bottomCenter {
    width: 970px;
  }
}
@media (min-width: 1280px) {
  .contentCenter,
  .systemCenter,
  .bottomCenter {
    width: 1200px;
  }
}
img {
  width: 100%;
  height: 100%;
}
.title {
  text-align: center;
  margin-top: 100px;
  font-size: 40px;
}
.text {
  text-align: center;
  font-size: 14px;
  color: #404040;
  margin: 0 auto;
  margin-top: 10px;
  width: 70%;
}
.park {
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
}
.parkLi {
  width: 48%;
  height: 330px;
  position: relative;
}
.parkText {
  padding: 20px;
  box-sizing: border-box;
  background-color: #000000;
  color: #fff;
  font-size: 14px;
  position: absolute;
  bottom: 0px;
  text-align: center;
  width: 100%;
  opacity: 0.8;
}
.parkTitle {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #bdbdbd;
  font-size: 20px;
  color: #fff;
}
.system {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  width: 100%;
  height: 300px;
  justify-content: center;
  margin-top: 130px;
}
.systemCenter {
  display: flex;
  justify-content: space-between;
}
.systemLi {
  position: relative;
  width: 32%;
}
.logo {
  width: 100px;
  height: 100px;
  position: absolute;
  text-align: center;
  line-height: 100px;
  color: #fff;
  font-size: 20px;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  background-color: #0171bb;
  display: flex;
  justify-content: center;
  align-items: center;
}
.systemTitle {
  font-weight: bold;
  font-size: 24px;
  color: #bdbdbd;
  text-align: center;
  margin-top: 20%;
}
.smallTitle {
  font-size: 16px;
  color: #bdbdbd;
  text-align: center;
  margin-top: 5%;
  height: 30%;
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.btnli {
  width: 144px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.technology {
  display: flex;
  margin-top: 70px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.technologyLi {
  width: 32%;
  height: 260px;
  line-height: 260px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  transition: all 0.4s;
}
.technologyLi:hover {
  transform: scale(1.05);
}
.partnerLi {
  width: 24%;
  height: 180px;
  line-height: 180px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  background-color: #bdbdbd;
  transition: all 0.4s;
}
.partnerLi:hover {
  transform: scale(1.05);
}
.parkBtn {
  background: #8d8d8d;
  /* opacity: 0.5; */
  width: 144px;
  height: 44px;
  line-height: 44px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  border-radius: 4px;
  cursor: not-allowed;
}
@media (max-width: 1200px) {
  .contentCenter {
    width: 100%;
  }
  .home_title {
    width: 85%;
    font-size: 13px;
  }
  img {
    width: 100%;
    height: 85%;
  }
}
@media (max-width: 425px) {
  .title {
    margin-top: 50px;
  }
  .title > span {
    font-size: 30px !important;
  }
  .text {
    padding: 0 10px;
    margin: 0;
    width: 100%;
    font-size: 12px !important;
    margin-top: 20px;
  }
  .park {
    flex-direction: column;
    margin-top: 40px;
  }
  .parkLi {
    width: 100%;
    height: 100%;
    margin-bottom: 5px;
  }
  .parkText {
    padding: 5px;
    font-size: 12px;
  }
  .text {
    font-size: 16px;
    /* text-indent: 2em; */
  }
  .content {
    padding-bottom: 30px;
  }
  .img_center {
    width: 100%;
  }
  .img_title {
    font-weight: bold;
    font-size: 30px;
    margin-top: 100px;
  }
  .img_content {
    font-size: 12px;
    line-height: 18px;
    /* text-indent: 2em; */
    width: 90%;
    margin-top: 20px;
  }
  .img_box {
    height: 270px;
  }
  .parkBtn{
    width: 100px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductCenter.vue